import { render, staticRenderFns } from "./VAnnotator.vue?vue&type=template&id=24577b23&scoped=true&"
import script from "./VAnnotator.vue?vue&type=script&lang=ts&"
export * from "./VAnnotator.vue?vue&type=script&lang=ts&"
import style0 from "./VAnnotator.vue?vue&type=style&index=0&id=24577b23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24577b23",
  null
  
)

export default component.exports